import type { ReactNode } from 'react';
import { ReadValueBox, SegmentButton, YearGroup } from './styles';

/** Переключатель года горизонта: «2026 · 2027 · …», базовый год подписан. */
export function YearSwitch({
  years,
  baseYear,
  value,
  onChange,
  label = 'Год расчёта',
}: {
  years: readonly number[];
  baseYear: number;
  value: number;
  onChange: (year: number) => void;
  label?: string;
}) {
  return (
    <YearGroup role="group" aria-label={label}>
      {years.map((y) => (
        <SegmentButton
          key={y}
          type="button"
          aria-pressed={y === value}
          title={y === baseYear ? 'Базовый год: цены блока «Цены» без индекса' : undefined}
          onClick={() => onChange(y)}
        >
          {y}
          {y === baseYear && (
            <>
              <span className="sep"> · </span>
              <span className="base">база</span>
            </>
          )}
        </SegmentButton>
      ))}
    </YearGroup>
  );
}

/** Подпись поля «только чтение» вместо поля ввода. */
export function ReadValue({ children }: { children: ReactNode }) {
  return <ReadValueBox>{children}</ReadValueBox>;
}
